<template>
  <el-button type="text" size="small" @click="toHandle">
    <slot></slot>
  </el-button>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      query: {
        id: ''
      },
      loading: false,
      submitIng: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {},
  methods: {
    toHandle() {
      const _this = this;
      _this.query = Object.assign(_this.query, _this.param);
      _this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.submitIng = true;
        _this.$apiAdmin.adminPeopleDelete(_this.query)
            .then(() => {
              _this.submitIng = false;
              _this.$message.success('删除成功')
              _this.$emit('finish')
            })
            .catch(err => {
              _this.submitIng = false;
              _this.$message.error(err.msg)
            })
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.index-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
</style>